import type { EntityStorefront } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

export const entityStorefrontQueryKey = (entityId: string) => ["getEntityStorefront", entityId];

export const useGetEntityStorefront = <TData = EntityStorefront>(
  entityId: Ref<string | undefined> | string | undefined,
  useQueryOptions?: Partial<UseQueryOptions<EntityStorefront, Error, TData>>,
) => {
  const getEntityStorefront = async (): Promise<EntityStorefront> => {
    return await learningServiceRequest({
      method: "get",
      url: `/entities/${unref(entityId)}/storefront/`,
      failureMessage: "Error loading Entity storefront data",
    }).then((response) => response?.data?.data?.items);
  };

  return useQuery<EntityStorefront, Error, TData>({
    queryKey: computed(() => entityStorefrontQueryKey(unref(entityId) ?? "")),
    queryFn: getEntityStorefront,
    ...useQueryOptions,
  });
};
